// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WjlWT","largestCol":"styles_largestCol__35BI8","smallestCol":"styles_smallestCol__Z3ZoC"};